import { render, staticRenderFns } from "./SignUp1.vue?vue&type=template&id=59a8f3af&"
import script from "./SignUp1.vue?vue&type=script&lang=ts&"
export * from "./SignUp1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports